import * as yup from "yup";

export default function schema(){
    const schema = yup.object({
        c1: yup.boolean().isTrue("Please confirm you do not have a MedStar Health network ID"),
        c2: yup.boolean().isTrue("Please confirm you do not have a MedStar Health employee ID"),
        c3: yup.boolean().isTrue("Please confirm you do not have a MedStar Health email")
    }).required();
    return schema;
}
